"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProjectionExpression = exports.getSelectionExpression = exports.getNextBracketedExpression = void 0;
var Option_1 = require("fp-ts/lib/Option");
var getIndexOfClosingParen_1 = require("./getIndexOfClosingParen");
var getNextBracketedExpression = function (setup) { return function (input) {
    var bracketClosesOn = setup.bracketClosesOn, bracketOpensOn = setup.bracketOpensOn, bracketNaivelyOpensOn = setup.bracketNaivelyOpensOn;
    var getIndexOfClosing = (0, getIndexOfClosingParen_1._getIndexOfClosingParen)(bracketNaivelyOpensOn, bracketClosesOn);
    var openerIx = input.indexOf(bracketOpensOn);
    var start = input.slice(0, openerIx);
    var rest = input.slice(openerIx + bracketOpensOn.length);
    if (openerIx !== -1) {
        var endIx = getIndexOfClosing(rest);
        if (endIx !== -1) {
            return (0, Option_1.some)({
                before: start,
                inner: rest.slice(0, endIx),
                after: rest.slice(endIx + bracketClosesOn.length),
            });
        }
    }
    return Option_1.none;
}; };
exports.getNextBracketedExpression = getNextBracketedExpression;
var getSelectionExpression = function (propertyExpression) {
    return (0, exports.getNextBracketedExpression)({
        bracketClosesOn: ']',
        bracketNaivelyOpensOn: '[',
        bracketOpensOn: '.?[',
    })(propertyExpression).map(function (_a) {
        var before = _a.before, inner = _a.inner, after = _a.after;
        return ({
            basePath: before,
            expression: inner,
            after: after,
        });
    });
};
exports.getSelectionExpression = getSelectionExpression;
var getProjectionExpression = function (propertyExpression) {
    return (0, exports.getNextBracketedExpression)({
        bracketClosesOn: ']',
        bracketNaivelyOpensOn: '[',
        bracketOpensOn: '.![',
    })(propertyExpression).map(function (_a) {
        var before = _a.before, inner = _a.inner, after = _a.after;
        return ({
            basePath: before,
            expression: inner,
            after: after,
        });
    });
};
exports.getProjectionExpression = getProjectionExpression;
//# sourceMappingURL=getSelectionExpression.js.map